import Color from '@/Enums/Color.enum';
import { Box, type SxProps, type Theme } from '@mui/material';
import type { PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren {
  sx?: SxProps<Theme>;
}

const SectionWrapper = ({ sx, children }: IProps) => {
  return (
    <Box sx={{ border: '1px solid', breakInside: 'avoid', borderRadius: '8px', borderColor: Color.GreyBorder, ...sx }}>
      {children}
    </Box>
  );
};

export default SectionWrapper;
